module.exports = __webpack_public_path__ + "static/SFUIText-Regular-201be5df4a219a87f1b86293d55acadb.woff2";